export const isEmailAddressValid = email => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (!email) {
    return undefined;
  }
  return emailRegex.test(email);
};
